import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import {
  client_detail_action,
  client_add_action,
} from "../../../actions/master_actions/client_action";
import { fill_action } from "../../../actions/fillList_action";
import Loader from "../../../utils/Loader";
import {
  accountTypeActionId,
  cityActionId,
  companyStatusActionId,
  countryActionId,
  sessionExpireMessage,
  stateActionId,
  tokenInavlidMessage,
} from "../../../utils/constants";
import {
  emailValidator,
  panNoValidator,
  gstNoValidator,
  tanNoValidator,
  notMendetoryEmailValidator,
  pincodeValidator,
  mobileNoValidator,
  notMendetoryMobileNoValidator,
} from "../../../utils/Validator";
import Select from "react-select";
import Header from "../../../common_components/Header";

class ClientAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      checkboxFlag: false,
      stateId: "",
      stateList: [],
      countryId: "",
      countryList: [],
      firstName: "",
      lastName: "",
      designation: "",
      companyName: "",
      addressLine1: "",
      addressLine2: "",
      cityId: "",
      cityList: [],
      pincode: "",
      Mobile1: "",
      Mobile2: "",
      primaryEmailID: "",
      secondaryEmailID: "",
      website: "",
      mobileISD1: "",
      mobileISD2: "",
      accountType: "",
      accountTypeList: [],
      AreaCode:"",
      SAAAreaCode:"",
      SameAsAbove: false,

      SAAFirstName: "",
      SAALastName: "",
      SAADesignation: "",
      SAACompanyName: "",
      SAAAddressLine1: "",
      SAAAddressLine2: "",
      SAACityId: "",
      SAAPincode: "",
      SAAMobile1: "",
      SAAMobile2: "",
      SAAPrimaryEmailID: "",
      SAASecondaryEmailID: "",
      SAAWebsite: "",
      SAAStateId: "",
      SAACountryId: "",
      SAATelephoneNumber: "",
      SAAMobileISD1: "",
      SAAMobileISD2: "",
      SAAISD: "",
      registrationNumber: "",
      PANCardNo: "",
      NameonPANCard: "",
      GSTNo: "",
      CompanyStatus: "",
      TANNumber: "",
      UINNumber: "",
      TelephoneNumber: "",

      accountName: "",
      accountNo: "",
      accountType: "",
      bankName: "",
      branchName: "",
      IFSCCode: "",
      companyStatusId: "",
      CityName: "",
      tempCityList: [],
      SAACityName: "",
      companyStatusList: [],
      ISD: "",

      CenterID: "",
      ClientID: "",
      Is_CenterID: false,
      MaxPAX: "",
      LastDate: "",

      // input validate
      companyStatusErr: "",
      firstNameErr: "",
      lastNameErr: "",
      organizerErr: "",
      addressLine1Err: "",
      addressLine2Err: "",
      CityNameErr: "",
      countryIdErr: "",
      pincodeErr: "",
      Mobile1Err: "",
      primaryEmailIDErr: "",
      SAAFirstNameErr: "",
      SAALastNameErr: "",
      SAAAddressLine1Err: "",
      SAAAddressLine2Err: "",
      SAACityNameErr: "",
      SAACountryIdErr: "",
      SAAPincodeErr: "",
      SAAMobile1Err: "",
      SAAPrimaryEmailIDErr: "",
      PANCardNoErr: "",
      NameonPANCardErr: "",
      accountNameErr: "",
      accountNoErr: "",
      accountTypeErr: "",
      bankNameErr: "",
      branchNameErr: "",
      IFSCCodeErr: "",
      SAACompanyNameErr: "",

      EventCordinatorName: "",
      EventCordinatorDesignation: "",
      EventCordinatorEmail: "",
      EventCordinatorMobile: "",
      PrimaryContactName: "",
      PrimaryContactDesignation: "",
      PrimaryContactEmail: "",
      PrimaryContactMobile: "",

      EventCordinatorNameErr: "",
      EventCordinatorDesignationErr: "",
      EventCordinatorEmailErr: "",
      EventCordinatorMobileErr: "",
      PrimaryContactNameErr: "",
      PrimaryContactDesignationErr: "",
      PrimaryContactEmailErr: "",
      PrimaryContactMobileErr: "",
      isDisplayCityList: false,
      isSAADisplayCityList: false,
      StatusID:"",

      isDisplayStateList: false,
      tempStateList: [],

      isSAADisplayStateList: false,
      tempSAAStateList: [],

      SAAStateList: [],
      SAAtempStateList: [],
      preTel: "",
      SAAPreTel: "",
      SAACityList: [],
      SAAtempCityList: [],
    };
    this.clientDetails = this.clientDetails.bind(this);
    this.navigateBackCLient = this.navigateBackCLient.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
      setTimeout(() => {
        {
          sessionStorage.getItem("roleId") == 4 ? (
            this.props.navigate("/checkList")
          ) : (
            <></>
          );
        }
      }, 10);
    }
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
          StatusID: this.props.location.state?.StatusID
          ? this.props.location.state?.StatusID
          : "",
    });
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    const { userId } = this.state;
    console.log("Props received:", this.props);
    console.log("Props.location.state received:", this.props.location.state);

    const ClientID = this.props.location.state?.ClientID || "";
    console.log("ClientID:", ClientID);

    if (ClientID) {
      this.setState({ ClientID }, () => {
        this.clientDetails();
      });
    }
    this.getFillList(stateActionId, '', 91, '')
    this.getFillList(countryActionId, '', 1, '')
    this.getFillList(cityActionId, '', 91, '')
    this.getFillList(accountTypeActionId, '', '', '')
  }

  getFillList(value, userID, keyword, keyvalue) {
    // this.setState({ isLoading: true })
    this.props
        .fill_action(value, (userID == '' || userID == null) ? null : userID, keyword != '' ? keyword : null, keyvalue != '' ? keyvalue : null)
        .then((data) => {
            if (data.error != 1) {
                if (value == stateActionId) {
                    this.setState({
                        stateList: data.data,
                        tempStateList: data.data,

                        SAAStateList: data.data,
                        SAAtempStateList: data.data,
                    })
                    console.log("stateActionId", data.data)
                }
                if (value == countryActionId) {
                    this.setState({ countryList: data.data, isLoading: false })
                    console.log("countryActionId", data.data)
                }
                if (value == cityActionId) {
                    this.setState({
                        cityList: data.data,
                        tempCityList: data.data,

                        SAACityList: data.data,
                        SAAtempCityList: data.data,
                    })
                    console.log("cityActionId", data.data)
                }
               
                if (value == accountTypeActionId) {
                    this.setState({ accountTypeList: data.data, isLoading: false })
                    console.log("accountTypeActionId", data.data)
                }


            }
        })
        .catch((e) => {
            console.log(e);
        });

}

  
     // search city
     onCitytSearch(e) {
      const { cityList, tempCityList, billTempCityList, cityId, countryId, SameAsAbove } = this.state
      if (countryId == '91' || countryId == '' || countryId == 'Country*') {
          if (e.target.value != '') {
              var searchCityList = tempCityList.filter(data => {
                  return (
                      data
                          .CityName
                          .toLowerCase()
                          .includes(e.target.value.toLowerCase())
                  )
              })
              this.setState({
                  cityId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' '),
                  CityNameErr: '',
                  tempCityList: searchCityList,
                  isDisplayCityList: true
              })
          } else {
              this.setState({
                  cityId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' '),
                  tempCityList: cityList,
                  isDisplayCityList: false
              })
          }
          if (SameAsAbove) {
              this.setState({
                  SAACityId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' '), SAACityNameErr: ''
              })
          }
      } else {
          this.setState({
              cityId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' '),
              isDisplayCityList: false,
              CityNameErr: '',
          })
          if (SameAsAbove) {
              this.setState({
                  SAACityId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' '), SAACityNameErr: ''
              })
          }
      }
  }

  // render city
  renderCityList() {
      const { tempCityList } = this.state
      return (
          <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 100 }}>
              {
                  tempCityList.length > 0 && tempCityList.map(data => (
                      <li class="list-group-item" key={Math.random()}
                          onClick={() => this.mainCityListData(data)}
                      >{data.CityName}</li>
                  ))
              }
          </ul>
      )
  }

  mainCityListData(data) {
      const { SameAsAbove } = this.state
      this.setState({ cityId: data.CityName, isDisplayCityList: false, CityNameErr: '' })

      if (SameAsAbove) {
          this.setState({ SAACityId: data.CityName, SAACityNameErr: '' })
      }
  }
  // same as above search city
  onSAACitytSearch(e) {
      const { SAACityList, SAAtempCityList, billTempCityList, cityId, SAACountryId } = this.state
      if (SAACountryId == '91' || SAACountryId == '' || SAACountryId == 'Country*') {
          console.log("SAAtempCityList +++++++++++++++++", SAAtempCityList)
          if (e.target.value != '') {
              var searchCityList = SAAtempCityList.filter(data => {
                  return (
                      data
                          .CityName
                          .toLowerCase()
                          .includes(e.target.value.toLowerCase())
                  )
              })
              this.setState({
                  SAACityId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' '),
                  SAACityNameErr: '',
                  SAAtempCityList: searchCityList,
                  isSAADisplayCityList: true
              })
          } else {
              this.setState({
                  SAACityId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' '),
                  SAAtempCityList: SAACityList,
                  isSAADisplayCityList: false
              })
          }
      } else {
          this.setState({
              SAACityNameErr: '',
              SAACityId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' '),
              isSAADisplayCityList: false
          })
      }
  }
  // same as above render city
  renderSAACityList() {
      const { SAAtempCityList } = this.state
      return (
          <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 100 }}>
              {
                  SAAtempCityList.length > 0 && SAAtempCityList.map(data => (
                      <li class="list-group-item" key={Math.random()}
                          onClick={() => this.mainSAACityListData(data)}
                      >{data.CityName}</li>
                  ))
              }
          </ul>
      )
  }
  mainSAACityListData(data) {

      this.setState({ SAACityId: data.CityName, isSAADisplayCityList: false, SAACityNameErr: '' })
  }
  // search State
  onStateSearch(e) {
      const { stateList, tempStateList, SameAsAbove, countryId } = this.state
      console.log("countryId -------------------onStateSearch", countryId)
      if (countryId == '91' || countryId == '' || countryId == 'Country*') {
          if (e.target.value != '') {
              var searchStateList = tempStateList.filter(data => {
                  return (
                      data
                          .Description
                          .toLowerCase()
                          .includes(e.target.value.toLowerCase())
                  )
              })
              this.setState({
                  stateId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' '),
                  stateErr: '',
                  tempStateList: searchStateList,
                  isDisplayStateList: true
              })
          } else {
              this.setState({
                  stateId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' '),
                  stateErr: '',
                  tempStateList: stateList,
                  isDisplayStateList: false
              })
          }
          if (SameAsAbove) {
              this.setState({
                  SAAStateId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' '), SAAStateErr: ''
              })
          }
      } else {
          this.setState({
              stateId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' '),
              isDisplayStateList: false,
              stateErr: '',
          })
          if (SameAsAbove) {
              this.setState({
                  SAAStateId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' '), SAAStateErr: ''
              })
          }
      }
  }
  // render State
  renderStateList() {
      const { tempStateList } = this.state
      return (
          <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 100, }}>
              {

                  tempStateList.length > 0 && tempStateList.map(data => (
                      <li class="list-group-item" key={Math.random()}
                          onClick={() => this.mainStateListData(data)}
                      >{data.Description}</li>
                  ))

              }
          </ul>
      )
  }
  mainStateListData(data) {
      const { SameAsAbove } = this.state
      this.setState({ stateId: data.Description, isDisplayStateList: false, stateErr: '' })

      if (SameAsAbove) {
          this.setState({ SAAStateId: data.Description, SAAStateErr: '' })
      }
  }
  // same as above search State
  onSAAStateSearch(e) {
      const { SAAStateList, tempSAAStateList, isDisplayStateList, SAACountryId } = this.state
      if (SAACountryId == '91' || SAACountryId == '' || SAACountryId == 'Country*') {
          if (e.target.value != '') {
              var searchStateList = tempSAAStateList.filter(data => {
                  return (
                      data
                          .Description
                          .toLowerCase()
                          .includes(e.target.value.toLowerCase())
                  )
              })
              this.setState({
                  SAAStateId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' '),
                  SAAStateErr: '',
                  tempSAAStateList: searchStateList,
                  isSAADisplayStateList: true
              })
          } else {
              this.setState({
                  SAAStateId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' '),
                  tempSAAStateList: SAAStateList,
                  isSAADisplayStateList: false
              })
          }
      } else {
          this.setState({
              SAAStateErr: '',
              SAAStateId: e.target.value.replace(/[^a-zA-Z ]/g, '').split(' ')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' '),
              isSAADisplayStateList: false
          })
      }
  }
  //same as above render State
  renderSAAStateList() {
      const { tempSAAStateList } = this.state
      return (
          <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 100 }}>
              {

                  tempSAAStateList.length > 0 && tempSAAStateList.map(data => (
                      <li class="list-group-item" key={Math.random()}
                          onClick={() => this.mainSAAStateListData(data)}
                      >{data.Description}</li>
                  ))

              }
          </ul>
      )
  }
  mainSAAStateListData(data) {

      this.setState({ SAAStateId: data.Description, isSAADisplayStateList: false, stateErr: '' })
  }
  SameAsAbove(e) {
    const { SameAsAbove, firstName, lastName, designation, TelephoneNumber, addressLine1, addressLine2, city, pincode, Mobile1, Mobile2, ISD, STD, primaryEmailID, secondaryEmailID, website, mobileISD1, mobileISD2, stateId, countryId, CityName, companyName, cityId, preTel, AreaCode } = this.state
    this.setState({ SameAsAbove: !SameAsAbove })
    if (!SameAsAbove) {
        this.setState({
            SAAFirstName: firstName,
            SAALastName: lastName,
            SAADesignation: designation,
            SAACompanyName: companyName,
            SAAAddressLine1: addressLine1,
            SAAAddressLine2: addressLine2,
            SAACityId: cityId,
            SAAPincode: pincode,
            SAAMobile1: Mobile1,
            SAAMobile2: Mobile2,
            SAAISD: ISD,
            SAASTD: STD,
            SAAPrimaryEmailID: primaryEmailID,
            SAASecondaryEmailID: secondaryEmailID,
            SAAWebsite: website,
            SAAStateId: stateId,
            SAACountryId: countryId,
            SAATelephoneNumber: TelephoneNumber,
            SAAMobileISD1: mobileISD1,
            SAAMobileISD2: mobileISD2,
            SAAPreTel: preTel,
            SAAAreaCode: AreaCode,
            SAAFirstNameErr: '',
            SAALastNameErr: '',
            SAACompanyNameErr: '',
            SAAAddressLine1Err: '',
            SAACityNameErr: '',
            SAACountryIdErr: '',
            SAAPincodeErr: '',
            SAAMobile1Err: '',
            SAAPrimaryEmailIDErr: '',
            SAAStateErr: ''

        })
        console.log("stateId", stateId)
        console.log("countryId", countryId)
    } else {
        this.setState({
            SAAFirstName: '',
            SAALastName: '',
            SAADesignation: '',
            SAACompanyName: '',
            SAAAddressLine1: '',
            SAAAddressLine2: '',
            SAACityId: '',
            SAAPincode: '',
            SAAMobile1: '',
            SAAMobile2: '',
            SAAISD: '',
            SAASTD: '',
            SAAPrimaryEmailID: '',
            SAASecondaryEmailID: '',
            SAAWebsite: '',
            SAAStateId: '',
            SAACountryId: '',
            SAATelephoneNumber: '',
            SAAMobileISD1: '',
            SAAMobileISD2: '',
            SAACityId: '',
            SAAPreTel: '',
        })
    }
}
  inputValidate() {
    const {
      firstName,
      lastName,
      designation,
      companyName,
      addressLine1,
      addressLine2,
      stateId,
      cityId,
      cityList,
      pincode,
      Mobile1,
      Mobile2,
      ISD,
      primaryEmailID,
      secondaryEmailID,
      website,
      SameAsAbove,
      SAAFirstName,
      SAALastName,
      SAADesignation,
      SAAAddressLine1,
      SAAAddressLine2,
      SAACityId,
      SAAPincode,
      SAAMobile1,
      SAAMobile2,
      SAAISD,
      SAASTD,
      SAAPrimaryEmailID,
      SAASecondaryEmailID,
      SAAWebsite,
      SAAStateId,
      registrationNumber,
      PANCardNo,
      NameonPANCard,
      GSTNo,
      
      TANNumber,
      UINNumber,
      SAATelephoneNumber,
      TelephoneNumber,
      SAACountryId,
      mobileISD1,
      mobileISD2,
      SAAMobileISD1,
      SAAMobileISD2,
      isDisplayCityList,
      CityName,
      SAACityName,
      CenterID,
      accountName,
      accountNo,
      accountType,
      bankName,
      branchName,
      IFSCCode,
      countryId,
      SAACompanyName,
      EventCordinatorName,
      EventCordinatorDesignation,
      EventCordinatorEmail,
      EventCordinatorMobile,
      PrimaryContactName,
      PrimaryContactDesignation,
      PrimaryContactEmail,
      PrimaryContactMobile,
    } = this.state;

    console.log("*******************", stateId);

    if (firstName == "" || firstName == null) {
      this.setState({ firstNameErr: "Please enter first name" });
    }
    if (lastName == "" || lastName == null) {
      this.setState({ lastNameErr: "Please enter last name" });
    }
    if (companyName == "" || companyName == null) {
      this.setState({ organizerErr: "Please enter organizer name" });
    }
    if (addressLine1 == "" || addressLine1 == null) {
      this.setState({ addressLine1Err: "Please enter address line 1" });
    }
    if (addressLine2 == "" || addressLine2 == null) {
      this.setState({ addressLine2Err: "Please enter address line 2" });
    }
    if (cityId == "" || cityId == null) {
      this.setState({
        CityNameErr: "Please enter city",
        isDisplayCityList: false,
      });
    }
    if (stateId == "" || stateId == null) {
      this.setState({ stateErr: "Please select state" });
    }
    if (countryId == "" || countryId == "Country*" || countryId == null) {
      this.setState({ countryIdErr: "Please select country" });
    }
    if (pincode == "" || pincode == null) {
      if (countryId == "91" || countryId == "" || countryId == "Country*") {
        this.setState({ pincodeErr: "Please enter pincode" });
      } else {
        this.setState({ pincodeErr: "Please enter zipCode" });
      }
    }
    if (Mobile1 == "" || Mobile1 == null) {
      this.setState({ Mobile1Err: "Please enter mobile number" });
    }
    if (primaryEmailID == "" || primaryEmailID == null) {
      this.setState({ primaryEmailIDErr: "Please enter email id" });
    }
    if (SAAFirstName == "" || SAAFirstName == null) {
      this.setState({ SAAFirstNameErr: "Please enter first name" });
    }
    if (SAALastName == "" || SAALastName == null) {
      this.setState({ SAALastNameErr: "Please enter last name" });
    }
    if (SAACompanyName == "" || SAACompanyName == null) {
      this.setState({ SAACompanyNameErr: "Please enter organizer name" });
    }
    if (SAAAddressLine1 == "" || SAAAddressLine1 == null) {
      this.setState({ SAAAddressLine1Err: "Please enter address line 1" });
    }
    if (SAAAddressLine2 == "" || SAAAddressLine2 == null) {
      this.setState({ SAAAddressLine2Err: "Please enter address line 2" });
    }
    if (SAACityId == "" || SAACityId == null) {
      this.setState({
        SAACityNameErr: "Please enter city",
        isSAADisplayCityList: false,
      });
    }
    if (SAAStateId == "" || SAAStateId == null) {
      this.setState({ SAAStateErr: "Please select state" });
    }
    if (
      SAACountryId == "" ||
      SAACountryId == "Country*" ||
      SAACountryId == null
    ) {
      this.setState({ SAACountryIdErr: "Please select country" });
    }
    if (SAAPincode == "" || SAAPincode == null) {
      if (
        SAACountryId == "91" ||
        SAACountryId == "" ||
        SAACountryId == "Country*"
      ) {
        this.setState({ SAAPincodeErr: "Please enter pincode" });
      } else {
        this.setState({ SAAPincodeErr: "Please enter zipCode" });
      }
    }
    if (SAAMobile1 == "" || SAAMobile1 == null) {
      this.setState({ SAAMobile1Err: "Please enter mobile number" });
    }
    if (SAAPrimaryEmailID == "" || SAAPrimaryEmailID == null) {
      this.setState({ SAAPrimaryEmailIDErr: "Please enter email id" });
    }
    if (PANCardNo == "" || PANCardNo == null) {
      this.setState({ PANCardNoErr: "Please enter pancard number" });
    }
    if (NameonPANCard == "" || NameonPANCard == null) {
      this.setState({ NameonPANCardErr: "Please enter name on pancard" });
    }
    if (accountName == "" || accountName == null) {
      this.setState({ accountNameErr: "Please enter account name" });
    }
    if (accountNo == "" || accountNo == null) {
      this.setState({ accountNoErr: "Please enter account number" });
    }
    if (
      accountType == "" ||
      accountType == "Select" ||
      accountType == "Account Type*" ||
      accountType == null
    ) {
      this.setState({ accountTypeErr: "Please select account type" });
    }
    if (bankName == "" || bankName == null) {
      this.setState({ bankNameErr: "Please enter bank name" });
    }
    if (branchName == "" || branchName == null) {
      this.setState({ branchNameErr: "Please enter branch name" });
    }
    if (IFSCCode == "" || IFSCCode == null) {
      if (countryId == "91" || countryId == "" || countryId == "Country*") {
        this.setState({ IFSCCodeErr: "Please enter IFSC code" });
      } else {
        this.setState({ IFSCCodeErr: "Please enter Swift code" });
      }
    }
    // event Cordinator details
    if (EventCordinatorName == "" || EventCordinatorName == null) {
      this.setState({
        EventCordinatorNameErr: "Please enter event cordinator name",
      });
    }
    if (
      EventCordinatorDesignation == "" ||
      EventCordinatorDesignation == null
    ) {
      this.setState({
        EventCordinatorDesignationErr:
          "Please enter event cordinator designation",
      });
    }
    if (EventCordinatorEmail == "" || EventCordinatorEmail == null) {
      this.setState({
        EventCordinatorEmailErr: "Please enter event cordinator email",
      });
    }

    if (EventCordinatorMobile == "" || EventCordinatorMobile == null) {
      this.setState({
        EventCordinatorMobileErr: "Please enter event cordinator mobile no",
      });
    }

    // primary contact details
    if (PrimaryContactName == "" || PrimaryContactName == null) {
      this.setState({
        PrimaryContactNameErr: "Please enter primary contact name",
      });
    }
    if (PrimaryContactDesignation == "" || PrimaryContactDesignation == null) {
      this.setState({
        PrimaryContactDesignationErr:
          "Please enter primary contact designation",
      });
    }
    if (PrimaryContactEmail == "" || PrimaryContactEmail == null) {
      this.setState({
        PrimaryContactEmailErr: "Please enter primary contact email",
      });
    }
    if (PrimaryContactMobile == "" || PrimaryContactMobile == null) {
      this.setState({
        PrimaryContactMobileErr: "Please enter primary contact mobile no",
      });
    }
  }
  onCountryId(e) {
    const { countryList, countryId, SameAsAbove, ISD } = this.state
    this.setState({ countryId: e.target.value, countryIdErr: '' })


    countryList.map((data) => {
        if (data.Countryid == e.target.value) {
            console.log("************* e target value 1234", data.ExtensionCode)
            this.setState({ ISD: data.ExtensionCode })
            if (SameAsAbove) {
                this.setState({ SAAISD: data.ExtensionCode })
            }
        }
    })

    setTimeout(() => {
        if (SameAsAbove) {
            this.setState({
                SAACountryId: e.target.value,
                SAACountryIdErr: '',
            })
            if (e.target.value != 91) {
                this.setState({
                    SAAPincode: '',
                    SAACityId: '',
                    SAAStateId: '',
                    SAAAddressLine1: '',
                    SAAAddressLine2: '',
                })
            }
        }
    }, 100);


    if (e.target.value == '91') {

        this.getFillList(stateActionId, '', e.target.value, '')
        this.getFillList(cityActionId, '', e.target.value, '')
    } else {
        this.setState({
            PANCardNo: '',
            PANCardNoErr: '',
            TANNumber: '',
            UINNumber: '',
            GSTNo: '',
            registrationNumber: '',
            NameonPANCard: '',
            NameonPANCardErr: '',
            PANCardNoErr: '',
            NameonPANCardErr: '',
            accountName: '',
            accountNo: '',
            accountType: '',
            bankName: '',
            branchName: '',
            IFSCCode: '',
            accountNameErr: '',
            accountNoErr: '',
            accountTypeErr: '',
            bankNameErr: '',
            branchNameErr: '',
            IFSCCodeErr: '',
        })
    }

    if (e.target.value != 91) {
        this.setState({
            cityId: '',
            stateId: '',
            pincode: '',
            isDisplayStateList: false,
            isDisplayCityList: false,
            addressLine1: '',
            addressLine2: '',
            CityNameErr: '',
            stateErr: '',
            pincodeErr: '',
        })
    } else {
        this.setState({
            CityNameErr: '',
            stateErr: '',
            pincodeErr: '',
        })
    }
}

onSAACountryId(e) {
    const { countryList, SAACountryId } = this.state
    this.setState({ SAACountryId: e.target.value, SAACountryIdErr: '' })
    if (e.target.value != '') {
        countryList.map((data) => {
            if (data.Countryid == e.target.value) {
                console.log("************* e target value", e.target.value)
                setTimeout(() => {
                    this.setState({ SAAISD: data.ExtensionCode })
                }, 100);
            } else {
                this.setState({
                    SAAISD: '',
                })
            }
        })
    }
    if (e.target.value == '91') {
        this.getFillList(stateActionId, '', e.target.value, '')
        this.getFillList(cityActionId, '', e.target.value, '')
    }
    if (e.target.value != 91) {
        this.setState({
            SAACityId: '',
            SAAStateId: '',
            SAAPincode: '',
            SAAAddressLine1: '',
            SAAAddressLine2: '',
            isSAADisplayStateList: false,
            isSAADisplayCityList: false,
            SAACityNameErr: '',
            SAAStateErr: '',
            SAAPincodeErr: '',
        })
    } else {
        this.setState({
            SAACityNameErr: '',
            SAAStateErr: '',
            SAAPincodeErr: '',
        })
    }
}
  firstName(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      firstName: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      firstNameErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAAFirstName: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAAFirstNameErr: "",
      });
    }
  }

  lastName(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      lastName: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      lastNameErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAALastName: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAALastNameErr: "",
      });
    }
  }

  designation(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      designation: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
    });
    if (SameAsAbove) {
      this.setState({
        SAADesignation: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
      });
    }
  }

  organizerName(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      companyName: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      organizerErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAACompanyName: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAACompanyNameErr: "",
      });
    }
  }

  addressLine1(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      addressLine1: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      addressLine1Err: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAAAddressLine1: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAAAddressLine1Err: "",
      });
    }
  }

  addressLine2(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      addressLine2: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      addressLine2Err: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAAAddressLine2: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAAAddressLine2Err: "",
      });
    }
  }

  pincode(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      pincode: e.target.value.replace(/\D/, ""),
      pincodeErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAAPincode: e.target.value.replace(/\D/, ""),
        SAAPincodeErr: "",
      });
    }
  }

  mobile1(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      Mobile1: e.target.value.replace(/\D/, ""),
      Mobile1Err: "",
    });
    if (SameAsAbove) {
      this.setState({ SAAMobile1: e.target.value, SAAMobile1Err: "" });
    }
  }

  mobile2(e) {
    const { SameAsAbove } = this.state;
    this.setState({ Mobile2: e.target.value.replace(/\D/, "") });
    if (SameAsAbove) {
      this.setState({ SAAMobile2: e.target.value });
    }
  }

  telephone(e) {
    const { SameAsAbove } = this.state;
    this.setState({ TelephoneNumber: e.target.value.replace(/\D/, "") });
    if (SameAsAbove) {
      this.setState({ SAATelephoneNumber: e.target.value });
    }
  }

  primaryEmail(e) {
    const { SameAsAbove } = this.state;
    this.setState({ primaryEmailID: e.target.value, primaryEmailIDErr: "" });
    if (SameAsAbove) {
      this.setState({
        SAAPrimaryEmailID: e.target.value,
        SAAPrimaryEmailIDErr: "",
      });
    }
  }

  secondaryEmail(e) {
    const { SameAsAbove } = this.state;
    this.setState({ secondaryEmailID: e.target.value });
    if (SameAsAbove) {
      this.setState({ SAASecondaryEmailID: e.target.value });
    }
  }

  website(e) {
    const { SameAsAbove } = this.state;
    this.setState({ website: e.target.value });
    if (SameAsAbove) {
      this.setState({ SAAWebsite: e.target.value });
    }
  }
  preTelephone(e) {
    const { SameAsAbove } = this.state;
    this.setState({ preTel: e.target.value });
    if (SameAsAbove) {
      this.setState({ SAAPreTel: e.target.value });
    }
  }
  areaCode(e) {
    const { SameAsAbove } = this.state
    this.setState({ AreaCode: e.target.value })
    if (SameAsAbove) {
        this.setState({ SAAAreaCode: e.target.value })
    }
}
  navigateBackCLient() {
    this.props.navigate("/client");
  }
  clearFields() {
    this.setState({
      ClientID: "",
      FirstName: "",
      LastName: "",
      Designation: "",
      CompanyName: "",
      AddressLine1: "",
      AddressLine2: "",
      CityID: "",
      StateID: "",
      Countryid: "",
      Pincode: "",
      Mobile1: "",
      Mobile2: "",
      Telephone: "",
      PrimaryEmailID: "",
      SecondaryEmailID: "",
      Website: "",
      IS_SameAsAbove: "",
      Inv_FirstName: "",
      Inv_LastName: "",
      Inv_Designation: "",
      Inv_CompanyName: "",
      Inv_AddressLine1: "",
      Inv_AddressLine2: "",
      Inv_CityID: "",
      Inv_StateID: "",
      Inv_Countryid: "",
      Inv_Pincode: "",
      Inv_Mobile1: "",
      Inv_Mobile2: "",
      Inv_Telephone: "",
      Inv_PrimaryEmailID: "",
      Inv_SecondaryEmailID: "",
      Inv_Website: "",
      CompanyRegistrationNo: "",
      PanNo: "",
      NameOnPanCard: "",
      GSTNo: "",
      TanNo: "",
      UINNo: "",
      accountName: "",
      accountNo: "",
      accountType: "",
      bankName: "",
      branchName: "",
      IFSCCode: "",
    });
  }

  clientDetails() {
    var ClientID = this.props.location.state.ClientID;
    console.log(ClientID, "-----------");
    this.setState({ isLoading: true });
    this.props
      .client_detail_action(ClientID)
      .then((data) => {
        console.log("Client details--------", data);
        if (data.error != 1) {
          this.setState({ isLoading: false });
          console.log(
            "data.data[0]['FirstName']------------",
            data.data[0]["FirstName"]
          );
          this.setState({
            firstName: data.data[0]["FirstName"],
            lastName: data.data[0]["LastName"],
            designation: data.data[0]["Designation"],
            companyName: data.data[0]["CompanyName"],
            addressLine1: data.data[0]["AddressLine1"],
            addressLine2: data.data[0]["AddressLine2"],
            cityId: data.data[0]["CityName"],
            SAACityId: data.data[0]["Inv_CityName"],
            stateId: data.data[0]["StateName"],
            countryId: data.data[0]["CountryID"],
            pincode: data.data[0]["Pincode"],
            Mobile1: data.data[0]["Mobile1"],
            Mobile2: data.data[0]["Mobile2"],
            TelephoneNumber: data.data[0]["Telephone"],
            primaryEmailID: data.data[0]["PrimaryEmailID"],
            secondaryEmailID: data.data[0]["SecondaryEmailID"],
            website: data.data[0]["Website"],
            SameAsAbove: data.data[0]["IS_SameAsAbove"],
            SAAFirstName: data.data[0]["Inv_FirstName"],
            SAALastName: data.data[0]["Inv_LastName"],
            SAADesignation: data.data[0]["Inv_Designation"],
            SAACompanyName: data.data[0]["Inv_CompanyName"],
            SAAAddressLine1: data.data[0]["Inv_AddressLine1"],
            SAAAddressLine2: data.data[0]["Inv_AddressLine2"],
            SAACityName: data.data[0]["Inv_CityName"],
            SAAStateId: data.data[0]["Inv_StateName"],
            SAACountryId: data.data[0]["Inv_CountryID"],
            SAAPincode: data.data[0]["Inv_Pincode"],
            SAAMobile1: data.data[0]["Inv_Mobile1"],
            SAAMobile2: data.data[0]["Inv_Mobile2"],
            SAATelephoneNumber: data.data[0]["Inv_Telephone"],
            SAAPrimaryEmailID: data.data[0]["Inv_PrimaryEmailID"],
            SAASecondaryEmailID: data.data[0]["Inv_SecondaryEmailID"],
            SAAWebsite: data.data[0]["Inv_Website"],
            registrationNumber: data.data[0]["CompanyRegistrationNo"],
            PANCardNo: data.data[0]["PanNo"],
            NameonPANCard: data.data[0]["NameOnPanCard"],
            GSTNo: data.data[0]["GSTNo"],
            TANNumber: data.data[0]["TanNo"],
            UINNumber: data.data[0]["UINNo"],
            ClientID: data.data[0]["ClientID"],
            accountName: data.data[0]["AccountName"],
            accountNo: data.data[0]["AccountNo"],
            accountType: data.data[0]["AccountType"],
            bankName: data.data[0]["BankName"],
            branchName: data.data[0]["BranchName"],
            IFSCCode: data.data[0]["IFSCCode"],
            EventCordinatorName: data.data[0]["EventCordinatorName"],
            EventCordinatorDesignation:
              data.data[0]["EventCordinatorDesignation"],
            EventCordinatorEmail: data.data[0]["EventCordinatorEmail"],
            EventCordinatorMobile: data.data[0]["EventCordinatorMobile"],
            PrimaryContactName: data.data[0]["PrimaryContactName"],
            PrimaryContactDesignation:
              data.data[0]["PrimaryContactDesignation"],
            PrimaryContactEmail: data.data[0]["PrimaryContactEmail"],
            PrimaryContactMobile: data.data[0]["PrimaryContactMobile"],
          });
          const { countryList, countryId } = this.state;
          // for (var i = 0; i < countryList.length; i++) {

          //     if (data.data['data'][0]['CountryID'] == 1) {

          //         this.setState({ ISD: countryList[i]['ExtensionCode'] })
          //         setTimeout(() => {
          //             console.log("ISD", this.state.ISD)
          //         }, 300);
          //     }
          // }
          if (data.data['data'][0]['Telephone'] != null && data.data['data'][0]['Telephone'].includes('-')) {
            const concateData = data.data['data'][0]['Telephone'].split('-')
            this.setState({ preTel: concateData[0], AreaCode: concateData[1], TelephoneNumber: concateData[2] })
        } else {
            this.setState({ TelephoneNumber: data.data['data'][0]['Telephone'] })
        }

        if (data.data['data'][0]['Inv_Telephone'] != null && data.data['data'][0]['Inv_Telephone'].includes('-')) {
            const concateData = data.data['data'][0]['Inv_Telephone'].split('-')
            this.setState({ SAAPreTel: concateData[0], SAAAreaCode: concateData[1], SAATelephoneNumber: concateData[2] })
        } else {
            this.setState({ SAATelephoneNumber: data.data['data'][0]['Inv_Telephone'] })
        }
          setTimeout(() => {
            countryList.map((itme) => {
              if (itme.Countryid == data.data[0]["CountryID"]) {
                this.setState({ ISD: itme.ExtensionCode });
              }
            });
          }, 200);

          setTimeout(() => {
            countryList.map((itme) => {
              if (itme.Countryid == data.data[0]["Inv_CountryID"]) {
                this.setState({ SAAISD: itme.ExtensionCode });
              }
            });
          }, 200);
        } else {
          if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position:"top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
        }else{
          this.setState({ isLoading: false });
          toast.error(data.data, {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }}
      })
      .catch((e) => {
        console.log(e);
      });
  }
  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  handleSubmit(event) {

    const { firstName, lastName, designation, companyName, addressLine1, addressLine2, stateId, countryId, pincode, Mobile1, Mobile2, TelephoneNumber, primaryEmailID, secondaryEmailID, website, SameAsAbove, SAAFirstName, SAALastName, SAADesignation, SAAAddressLine1, SAAAddressLine2, cityId, SAAStateId, SAACountryId, SAAPincode, SAAMobile1, SAAMobile2, SAATelephoneNumber, SAAPrimaryEmailID, SAASecondaryEmailID, SAAWebsite, registrationNumber, PANCardNo, NameonPANCard, GSTNo,  TANNumber, UINNumber, SAACityId, CityName, cityList, SAACityName,  ClientID, accountName, accountNo, accountType, bankName, branchName, IFSCCode, CenterID, bookingList, SAACompanyName, SAAPreTel, preTel, is_Update_Membership, EventCordinatorName, EventCordinatorDesignation, EventCordinatorEmail, EventCordinatorMobile, PrimaryContactName, PrimaryContactDesignation, PrimaryContactEmail, PrimaryContactMobile, AreaCode, SAAAreaCode,StatusID } = this.state
    const isEdit = this.props.location.state != null && this.props.location.state.isEdit != null ? this.props.location.state.isEdit : null


    setTimeout(() => {
        this.inputValidate()
    }, 100);
    if (countryId == '91') {

        if (firstName != '' && firstName != null && lastName != '' && lastName != null && companyName != '' && companyName != null && addressLine1 != '' && addressLine1 != null && stateId != null && stateId != '' && countryId != '' && countryId != null && countryId == '91' && countryId != 'Country*' && cityId != '' && cityId != null && pincode != '' && pincode != null && Mobile1 != '' && Mobile1 != null && primaryEmailID != '' && primaryEmailID != null && SAAFirstName != '' && SAAFirstName != null && SAALastName != '' && SAALastName != null && SAACompanyName != '' && SAACompanyName != null && SAAAddressLine1 != '' && SAAAddressLine1 != null && SAACountryId != '' && SAACountryId != null && SAACountryId != 'Country*' && SAAStateId != null && SAAStateId != '' && SAACityId != '' && SAACityId != null && SAAPincode != '' && SAAPincode != null && SAAMobile1 != '' && SAAMobile1 != null && SAAPrimaryEmailID != '' && SAAPrimaryEmailID != null && PANCardNo != '' && PANCardNo != null && NameonPANCard != '' && NameonPANCard != null && accountName != '' && accountName != null && accountNo != '' && accountNo != null && accountType != '' && accountType != null && accountType != 'Select' && accountType != 'Account Type*' && bankName != '' && bankName != null && branchName != '' && branchName != null && IFSCCode != '' && IFSCCode != null && EventCordinatorName != '' && EventCordinatorName != null && EventCordinatorDesignation != '' && EventCordinatorDesignation != null && EventCordinatorEmail != '' && EventCordinatorEmail != null && EventCordinatorMobile != '' && EventCordinatorMobile != null && PrimaryContactName != '' && PrimaryContactName != null && PrimaryContactDesignation != '' && PrimaryContactDesignation != null && PrimaryContactEmail != '' && PrimaryContactEmail != null && PrimaryContactMobile != '' && PrimaryContactMobile != null) {

            var errMsg1 = emailValidator(primaryEmailID)
            var errMsg2 = notMendetoryEmailValidator(secondaryEmailID)
            var errMsg3 = emailValidator(SAAPrimaryEmailID)
            var errMsg4 = notMendetoryEmailValidator(SAASecondaryEmailID)
            var panErrMsg = panNoValidator(PANCardNo)
            var gstErrMsg = gstNoValidator(GSTNo)
            var tanErrMsg = tanNoValidator(TANNumber)
            var pincodeErrMsg = pincodeValidator(pincode)
            var pincodeSaaErrMsg = pincodeValidator(SAAPincode)
            var mobile1ErrMsg = mobileNoValidator(Mobile1)
            var mobile2ErrMsg = notMendetoryMobileNoValidator(Mobile2)
            var SAAMobile1ErrMsg = mobileNoValidator(SAAMobile1)
            var SAAMobile2ErrMsg = notMendetoryMobileNoValidator(SAAMobile2)
            var EventCordinatorMobileErrMsg = mobileNoValidator(EventCordinatorMobile)
            var PrimaryContactMobileErrMsg = mobileNoValidator(PrimaryContactMobile)
            var EventCordinatorEmailErrMsg = emailValidator(EventCordinatorEmail)
            var PrimaryContactEmailErrMsg = emailValidator(PrimaryContactEmail)

            if (errMsg1 != '' || errMsg3 != '' || panErrMsg != '' || (pincodeErrMsg != '') || (pincodeSaaErrMsg != '') || (mobile1ErrMsg != '') || (SAAMobile1ErrMsg != '') || (EventCordinatorMobileErrMsg != '') || (PrimaryContactMobileErrMsg != '') || (EventCordinatorEmailErrMsg != '') || (PrimaryContactEmailErrMsg != '')) {

                toast.error(
                    errMsg1 != '' ? errMsg1 :
                        errMsg3 != '' ? errMsg3 :
                            panErrMsg != '' ? panErrMsg :
                                pincodeErrMsg != '' ? pincodeErrMsg :
                                    pincodeSaaErrMsg != '' ? pincodeSaaErrMsg :
                                        mobile1ErrMsg != '' ? mobile1ErrMsg :
                                            SAAMobile1ErrMsg != '' ? SAAMobile1ErrMsg :
                                                EventCordinatorMobileErrMsg != '' ? EventCordinatorMobileErrMsg :
                                                    PrimaryContactMobileErrMsg != '' ? PrimaryContactMobileErrMsg :
                                                        EventCordinatorEmailErrMsg != '' ? EventCordinatorEmailErrMsg :
                                                            PrimaryContactEmailErrMsg != '' ? PrimaryContactEmailErrMsg :
                                                                '',
                    {
                        position: "top-center",
                        theme: 'colored',
                        autoClose: 1000,
                        hideProgressBar: true,
                    })

                if (errMsg1) {
                    this.setState({ primaryEmailIDErr: 'Please enter proper email' })
                } else if (errMsg3) {
                    this.setState({ SAAPrimaryEmailIDErr: 'Please enter proper email' })
                } else if (panErrMsg) {
                    this.setState({ PANCardNoErr: 'Please enter proper PAN No' })
                } else if (pincodeErrMsg) {
                    this.setState({ pincodeErr: 'Please Enter proper pincode' })
                } else if (pincodeSaaErrMsg) {
                    this.setState({ SAAPincodeErr: 'Please Enter proper pincode' })
                } else if (mobile1ErrMsg) {
                    this.setState({ Mobile1Err: 'Please Enter proper mobile number' })
                } else if (SAAMobile1ErrMsg) {
                    this.setState({ SAAMobile1Err: 'Please Enter proper mobile number' })
                } else if (EventCordinatorMobileErrMsg) {
                    this.setState({ EventCordinatorMobileErr: 'Please Enter proper mobile number' })
                } else if (PrimaryContactMobileErrMsg) {
                    this.setState({ PrimaryContactMobileErr: 'Please Enter proper mobile number' })
                } else if (EventCordinatorEmailErrMsg) {
                    this.setState({ EventCordinatorEmailErr: 'Please enter proper email' })
                } else if (PrimaryContactEmailErrMsg) {
                    this.setState({ PrimaryContactEmailErr: 'Please enter proper email' })
                }

            }
            else if ((gstErrMsg != '') || (tanErrMsg != '') || (errMsg2 != '') || (errMsg4 != '') || (mobile2ErrMsg != '') || (SAAMobile2ErrMsg != '')) {

                toast.error(
                    gstErrMsg != '' ? gstErrMsg :
                        tanErrMsg != '' ? tanErrMsg :
                            errMsg2 != '' ? errMsg2 :
                                errMsg4 != '' ? errMsg4 :
                                    mobile2ErrMsg != '' ? mobile2ErrMsg :
                                        SAAMobile2ErrMsg != '' ? SAAMobile2ErrMsg :
                                            '',
                    {
                        position: "top-center",
                        theme: 'colored',
                        autoClose: 1000,
                        hideProgressBar: true,
                    })
            }

            else {
                if (Mobile1 != EventCordinatorMobile && Mobile1 != PrimaryContactMobile) {
                    this.setState({ isLoading: true })

                    this.props
                        .client_add_action(ClientID, firstName, lastName, designation, companyName, addressLine1, addressLine2, cityId, stateId, countryId, pincode, Mobile1, Mobile2,
                            TelephoneNumber != '' && TelephoneNumber != null && preTel != '' && preTel != null ? preTel + '-' + TelephoneNumber : TelephoneNumber,
                            primaryEmailID, secondaryEmailID, website, SameAsAbove, SAAFirstName, SAALastName, SAADesignation, SAACompanyName, SAAAddressLine1, SAAAddressLine2, SAACityId, SAAStateId, SAACountryId, SAAPincode, SAAMobile1, SAAMobile2,
                            SAATelephoneNumber != '' && SAATelephoneNumber != null && SAAPreTel != '' && SAAPreTel != null ? SAAPreTel + '-' + SAATelephoneNumber : SAATelephoneNumber,
                            SAAPrimaryEmailID, SAASecondaryEmailID, SAAWebsite, registrationNumber, PANCardNo, NameonPANCard, GSTNo,  TANNumber, UINNumber, accountName, accountNo, accountType, bankName, branchName, IFSCCode, EventCordinatorName, EventCordinatorDesignation, EventCordinatorEmail, EventCordinatorMobile, PrimaryContactName, PrimaryContactDesignation, PrimaryContactEmail, PrimaryContactMobile,0,StatusID)
                        .then((data) => {
                            if (data.error != 1) {
                                console.log("data.data", data.data)
                                this.setState({ isLoading: false })
                                this.props.navigate('/client')    

                            }
                            else {
                              if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
                                //after session expire.....................
                                sessionStorage.clear()
                                this.props.navigate('/normalView')
                                setTimeout(() => {
                                  toast.error(data.msg, {
                                    position:"top-center",
                                    theme: "colored",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                  });
                                }, 500);
                            }else{
                                this.setState({ isLoading: false })
                                toast.error(data.msg, {
                                    position: "top-center",
                                    theme: 'colored',
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                })
                            }}
                        })
                        .catch((e) => {
                            console.log(e);
                        });
                } else {
                    toast.error('Provide Different Contact Number for Event Coordinator!', {
                        position: "top-center",
                        theme: 'colored',
                        autoClose: 1000,
                        hideProgressBar: true,
                    })
                    this.mobileCheckedSameOrNot()
                }
            }
        }
        else {
            toast.error('Please enter mandatory fields!', {
                position: "top-center",
                theme: 'colored',
                autoClose: 1000,
                hideProgressBar: true,
            })
            this.setState({ isLoading: false })
        }
    } else {

        if (firstName != '' && firstName != null && lastName != '' && lastName != null && companyName != '' && companyName != null && countryId != '' && countryId != null && countryId != 'Country*' && stateId != null && stateId != '' && addressLine1 != '' && addressLine1 != null && cityId != '' && cityId != null && pincode != '' && pincode != null && Mobile1 != '' && Mobile1 != null && primaryEmailID != '' && primaryEmailID != null && SAAFirstName != '' && SAAFirstName != null && SAALastName != '' && SAALastName != null && SAACompanyName != '' && SAACompanyName != null && SAAAddressLine1 != '' && SAAAddressLine1 != null && SAACountryId != '' && SAACountryId != null && SAACountryId != '' && SAACountryId != 'Country*' && SAACityId != '' && SAACityId != null && SAAStateId != null && SAAStateId != '' && SAAPincode != '' && SAAPincode != null && SAAMobile1 != '' && SAAMobile1 != null && SAAPrimaryEmailID != '' && SAAPrimaryEmailID != null && accountName != '' && accountName != null && accountNo != '' && accountNo != null && accountType != '' && accountType != null && accountType != 'Select' && accountType != 'Account Type*' && bankName != '' && bankName != null && branchName != '' && branchName != null && IFSCCode != '' && IFSCCode != null && EventCordinatorName != '' && EventCordinatorName != null && EventCordinatorDesignation != '' && EventCordinatorDesignation != null && EventCordinatorEmail != '' && EventCordinatorEmail != null && EventCordinatorMobile != '' && EventCordinatorMobile != null && PrimaryContactName != '' && PrimaryContactName != null && PrimaryContactDesignation != '' && PrimaryContactDesignation != null && PrimaryContactEmail != '' && PrimaryContactEmail != null && PrimaryContactMobile != '' && PrimaryContactMobile != null) {


            var errMsg1 = emailValidator(primaryEmailID)
            var errMsg2 = notMendetoryEmailValidator(secondaryEmailID)
            var errMsg3 = emailValidator(SAAPrimaryEmailID)
            var errMsg4 = notMendetoryEmailValidator(SAASecondaryEmailID)
            var EventCordinatorEmailErrMsg = emailValidator(EventCordinatorEmail)
            var PrimaryContactEmailErrMsg = emailValidator(PrimaryContactEmail)
            if (errMsg1 != '' || errMsg3 != '' || EventCordinatorEmailErrMsg != '' || PrimaryContactEmailErrMsg != '') {

                console.log("stateId-------", stateId)
                console.log("cityId-------", cityId)
                toast.error(

                    errMsg1 != '' ? errMsg1 :
                        errMsg3 != '' ? errMsg3 :
                            EventCordinatorEmailErrMsg != '' ? EventCordinatorEmailErrMsg :
                                PrimaryContactEmailErrMsg != '' ? PrimaryContactEmailErrMsg :
                                    '',
                    {
                        position: "top-center",
                        theme: 'colored',
                        autoClose: 1000,
                        hideProgressBar: true,
                    })

                if (errMsg1) {
                    this.setState({ primaryEmailIDErr: 'Please enter proper email' })
                } else if (errMsg3) {
                    this.setState({ SAAPrimaryEmailIDErr: 'Please enter proper email' })
                } else if (EventCordinatorEmailErrMsg) {
                    this.setState({ EventCordinatorEmailErr: 'Please enter proper email' })
                } else if (PrimaryContactEmailErrMsg) {
                    this.setState({ PrimaryContactEmailErr: 'Please enter proper email' })
                }

            }
            // else if (errMsg2 != '' || errMsg4 != '' || mobile2ErrMsg != '' || SAAMobile2ErrMsg != '') {

            //     toast.error(
            //         errMsg2 != '' ? errMsg2 :
            //             errMsg4 != '' ? errMsg4 :
            //                 mobile2ErrMsg != '' ? mobile2ErrMsg :
            //                     SAAMobile2ErrMsg != '' ? SAAMobile2ErrMsg :
            //                         '',
            //         {
            //             position: "top-center",
            //             theme: 'colored',
            //             autoClose: 1000,
            //             hideProgressBar: true,
            //         })

            // }

            else {
                if (Mobile1 != EventCordinatorMobile && Mobile1 != PrimaryContactMobile) {
                    this.setState({ isLoading: true })
                    this.props
                        .client_add_action(ClientID, firstName, lastName, designation, companyName, addressLine1, addressLine2, cityId, stateId, countryId, pincode, Mobile1, Mobile2,
                            TelephoneNumber != '' && TelephoneNumber != null && (AreaCode != '' && preTel != '' ? preTel + '-' + AreaCode + '-' + TelephoneNumber : (preTel != '' ? preTel + '-' + TelephoneNumber : TelephoneNumber)),
                            primaryEmailID, secondaryEmailID, website, SameAsAbove, SAAFirstName, SAALastName, SAADesignation, SAACompanyName, SAAAddressLine1, SAAAddressLine2, SAACityId, SAAStateId, SAACountryId, SAAPincode, SAAMobile1, SAAMobile2,
                            SAATelephoneNumber != '' && SAATelephoneNumber != null && (SAAAreaCode != '' && SAAPreTel != '' ? SAAPreTel + '-' + SAAAreaCode + '-' + TelephoneNumber : (SAAPreTel != '' ? preTel + '-' + SAATelephoneNumber : SAATelephoneNumber))
                            ,
                            SAAPrimaryEmailID, SAASecondaryEmailID, SAAWebsite, registrationNumber, PANCardNo, NameonPANCard, GSTNo, TANNumber, UINNumber, accountName, accountNo, accountType, bankName, branchName, IFSCCode, EventCordinatorName, EventCordinatorDesignation, EventCordinatorEmail, EventCordinatorMobile, PrimaryContactName, PrimaryContactDesignation, PrimaryContactEmail, PrimaryContactMobile,0,StatusID)
                        .then((data) => {
                            if (data.error != 1) {
                                console.log("data.data", data.data)
                                this.setState({ isLoading: false })
                                this.props.navigate('/client')
                               
                            }
                            else {
                              if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
                                //after session expire.....................
                                sessionStorage.clear()
                                this.props.navigate('/normalView')
                                setTimeout(() => {
                                  toast.error(data.msg, {
                                    position:"top-center",
                                    theme: "colored",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                  });
                                }, 500);
                            }else{
                                this.setState({ isLoading: false })
                                toast.error(data.msg, {
                                    position: "top-center",
                                    theme: 'colored',
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                })
                            }}
                        })
                        .catch((e) => {
                            console.log(e);
                        });
                } else {
                    toast.error('MobileNo can not be same!', {
                        position: "top-center",
                        theme: 'colored',
                        autoClose: 1000,
                        hideProgressBar: true,
                    })
                    this.mobileCheckedSameOrNot()
                }
            }
        }
        else {
            toast.error('Please enter mandatory fields!', {
                position: "top-center",
                theme: 'colored',
                autoClose: 1000,
                hideProgressBar: true,
            })
            this.setState({ isLoading: false })
        }
    }
}
  render() {
    const {
      isLoading,
      stateId,
      stateList,
      countryId,
      countryList,
      firstName,
      lastName,
      designation,
      companyName,
      addressLine1,
      addressLine2,
      cityId,
      cityList,
      pincode,
      Mobile1,
      Mobile2,
      ISD,
      primaryEmailID,
      secondaryEmailID,
      website,
      SameAsAbove,
      SAAFirstName,
      SAALastName,
      SAADesignation,
      SAAAddressLine1,
      SAAAddressLine2,
      SAACityId,
      SAAPincode,
      SAAMobile1,
      SAAMobile2,
      SAAISD,
      SAASTD,
      SAAPrimaryEmailID,
      SAASecondaryEmailID,
      SAAWebsite,
      SAAStateId,
      registrationNumber,
      PANCardNo,
      NameonPANCard,
      GSTNo,
      TANNumber,
      UINNumber,
      SAATelephoneNumber,
      TelephoneNumber,
      SAACountryId,
      mobileISD1,
      mobileISD2,
      SAAMobileISD1,
      SAAMobileISD2,
      isDisplayCityList,
      CityName,
      SAACityName,
      CenterID,
      accountName,
      accountNo,
      accountType,
      bankName,
      branchName,
      IFSCCode,
      accountTypeList,
      SAACompanyName,
      firstNameErr,
      lastNameErr,
      organizerErr,
      addressLine1Err,
      addressLine2Err,
      CityNameErr,
      countryIdErr,
      pincodeErr,
      Mobile1Err,
      primaryEmailIDErr,
      SAAFirstNameErr,
      SAALastNameErr,
      SAAAddressLine1Err,
      SAAAddressLine2Err,
      SAACityNameErr,
      SAACountryIdErr,
      SAAPincodeErr,
      SAAMobile1Err,
      SAAPrimaryEmailIDErr,
      PANCardNoErr,
      NameonPANCardErr,
      accountNameErr,
      accountNoErr,
      accountTypeErr,
      bankNameErr,
      branchNameErr,
      IFSCCodeErr,
      SAACompanyNameErr,
      stateErr,
      SAAStateErr,
      isSAADisplayCityList,
      isDisplayStateList,
      isSAADisplayStateList,
      EventCordinatorName,
      EventCordinatorDesignation,
      EventCordinatorEmail,
      EventCordinatorMobile,
      PrimaryContactName,
      PrimaryContactDesignation,
      PrimaryContactEmail,
      PrimaryContactMobile,
      EventCordinatorNameErr,
      EventCordinatorDesignationErr,
      EventCordinatorEmailErr,
      EventCordinatorMobileErr,
      PrimaryContactNameErr,
      PrimaryContactDesignationErr,
      PrimaryContactEmailErr,
      PrimaryContactMobileErr,
      ClientID,
      preTel,
      SAAPreTel,AreaCode,SAAAreaCode,StatusID
    } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[11]} />

            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">
                    {ClientID ? "Edit" : "Add"} Client
                  </h4>
                  <div className="Service_display pt-2">
                    <h6 className="Services_Active_or_Not">{ClientID?StatusID == 1 ? "Active" : "Inactive":"Active"}</h6>
                    <div className="checkbox checbox-switch">
                      <label className="switch">
                      {ClientID?(
                             <>
                         
                             <input
                               type="checkbox"
                               checked={StatusID}
                               onChange={() => {
                                 this.setState((prevState) => ({
                                   StatusID: !prevState.StatusID,
                                 }));
                               }}
                             />
                             <span class="slider round"></span>
                             </>

                        ):(
                          <>
                          <input
                                                    type="checkbox"
                                                    checked={1}
                                                   
                                                  />
                                                  <span class="slider round"></span></>
                        )}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="card Service_fields">
                  <div className="card-body">
                    <div className="company_info">
                      <fieldset>
                        <legend>Name and full address of the Organizer</legend>
                        <div className="outside_input_field ">
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={firstName}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    maxLength={30}
                                    onChange={(e) => this.firstName(e)}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {firstNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    First Name{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={lastName}
                                    type="text"
                                    class="outside"
                                    required
                                    maxLength={30}
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.lastName(e)}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {lastNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Last Name{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={designation}
                                    type="text"
                                    class="outside"
                                    required
                                    maxLength={50}
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.designation(e)}
                                  />
                                  <span class="floating-label-outside">
                                    Designation
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={companyName}
                                    type="text"
                                    class="outside"
                                    required
                                    maxLength={100}
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.organizerName(e)}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {organizerErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Organizer / Organization Name{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group floating-group floating-diff">
                                <label class="floating-label">COUNTRY </label>
                                <select
                                  id="state"
                                  name="Entry Type"
                                  class="form-control floating-control"
                                  // onKeyDown={(e) => this.handleKeyDown(e)}
                                  value={countryId}
                                  onChange={(e) => this.onCountryId(e)}
                                >
                                  <option value="">
                                    Country
                                    <span class="mendatory_class">*</span>
                                  </option>
                                  {countryList.length > 0 &&
                                    countryList.map((item) => (
                                      <option
                                        key={item.Countryid}
                                        value={item.Countryid}
                                      >
                                        {item.CountryName}
                                      </option>
                                    ))}
                                </select>
                                {
                                  <span className="text-danger text-start text-left d-block mt-1">
                                    {countryIdErr}
                                  </span>
                                }
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={stateId}
                                    type="text"
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    class="outside"
                                    required
                                    onChange={(e) => this.onStateSearch(e)}
                                    autocomplete="off"
                                    maxLength={30}
                                  />
                                  {isDisplayStateList && this.renderStateList()}
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {stateErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    State Name
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={cityId}
                                    type="text"
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    class="outside"
                                    required
                                    onChange={(e) => this.onCitytSearch(e)}
                                    autocomplete="off"
                                    maxLength={30}
                                  />
                                  {isDisplayCityList && this.renderCityList()}
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {CityNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    City Name
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={addressLine1}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.addressLine1(e)}
                                    maxLength={70}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {addressLine1Err}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Address Line 1{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={addressLine2}
                                    type="text"
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    class="outside"
                                    required
                                    onChange={(e) => this.addressLine2(e)}
                                    maxLength={70}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {addressLine2Err}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Address Line 2{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={pincode}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.pincode(e)}
                                    maxLength={20}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {pincodeErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    {countryId == "91" ||
                                    countryId == "" ||
                                    countryId == "Country*"
                                      ? "Pincode"
                                      : "ZipCode"}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="tel_number">
                                  <div class="ISD">
                                    <input
                                      type="text"
                                      class="outside"
                                      placeholder="ISD"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      value={ISD}
                                      disabled={true}
                                    />
                                  </div>
                                  <div class="position-relative width_80">
                                    <input
                                      value={Mobile1}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) => this.mobile1(e)}
                                      maxLength={countryId == "91" ? 10 : 11}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {Mobile1Err}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      Mobile 1{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="tel_number">
                                  <div class="ISD">
                                    <input
                                      type="text"
                                      class="outside"
                                      placeholder="ISD"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      value={ISD}
                                      disabled={true}
                                    />
                                  </div>
                                  <div class="position-relative width_80">
                                    <input
                                      value={Mobile2}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) => this.mobile2(e)}
                                      maxLength={countryId == "91" ? 10 : 11}
                                    />
                                    <span class="floating-label-outside">
                                      Mobile 2
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="tel_number">
                                  <div class="ISD">
                                    <input
                                      type="text"
                                      class="outside"
                                      placeholder={
                                        countryId == "91" ||
                                        countryId == "" ||
                                        countryId == "Country*"
                                          ? "STD"
                                          : "ISD"
                                      }
                                      value={preTel}
                                      required
                                      onChange={(e) => this.preTelephone(e)}
                                      maxLength={5}
                                    />
                                  </div>
                                  {countryId != "91" &&
                                  countryId != "" &&
                                  countryId != "Country*" ? (
                                    <div class="ISD">
                                      <input
                                        type="text"
                                        class="outside"
                                        placeholder="CODE"
                                        value={AreaCode}
                                        required
                                        onChange={(e) => this.areaCode(e)}
                                        maxLength={10}
                                      />
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  <div class="position-relative width_80">
                                    <input
                                      type="text"
                                      class="outside"
                                      value={TelephoneNumber}
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) => this.telephone(e)}
                                      maxLength={16}
                                    />
                                    <span class="floating-label-outside">
                                      Telephone Number
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={primaryEmailID}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.primaryEmail(e)}
                                    maxLength={50}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {primaryEmailIDErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Primary Email ID{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={secondaryEmailID}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.secondaryEmail(e)}
                                    maxLength={50}
                                  />
                                  <span class="floating-label-outside">
                                    Secondary Email ID{" "}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={website}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.website(e)}
                                    maxLength={40}
                                  />
                                  <span class="floating-label-outside">
                                    Website{" "}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset>
                        <legend>Event Coordinator details </legend>

                        <div class="outside_input_field ">
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={EventCordinatorName}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    maxLength={30}
                                    onChange={(e) => this.setState({
                                      EventCordinatorName: e.target.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s+/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '), EventCordinatorNameErr: ''
                                  })}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {EventCordinatorNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    {" "}
                                    Name <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={EventCordinatorDesignation}
                                    type="text"
                                    class="outside"
                                    required
                                    maxLength={30}
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.setState({
                                      EventCordinatorDesignation: e.target.value.split(' ')
                                          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                          .join(' '), EventCordinatorDesignationErr: ''
                                  })}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {EventCordinatorDesignationErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Designation
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={EventCordinatorEmail}
                                    type="text"
                                    class="outside"
                                    required
                                    maxLength={30}
                                    onChange={(e) =>
                                      this.setState({
                                        EventCordinatorEmail: e.target.value,
                                        EventCordinatorEmailErr: "",
                                      })
                                    }
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {EventCordinatorEmailErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Email<span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={EventCordinatorMobile}
                                    type="text"
                                    class="outside"
                                    required
                                    maxLength={30}
                                    onChange={(e) =>
                                      this.setState({
                                        EventCordinatorMobile:
                                          e.target.value.replace(/\D/, ""),
                                        EventCordinatorMobileErr: "",
                                      })
                                    }
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {EventCordinatorMobileErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Mobile<span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>

                      <fieldset>
                        <legend>Primary Contact details </legend>

                        <div class="outside_input_field ">
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={PrimaryContactName}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    maxLength={30}
                                    onChange={(e) => this.setState({
                                      PrimaryContactName: e.target.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s+/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '), PrimaryContactNameErr: ''
                                  })}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {PrimaryContactNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    {" "}
                                    Name <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={PrimaryContactDesignation}
                                    type="text"
                                    class="outside"
                                    required
                                    maxLength={30}
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.setState({
                                      PrimaryContactDesignation: e.target.value.split(' ')
                                          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                          .join(' '), PrimaryContactDesignationErr: ''
                                  })}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {PrimaryContactDesignationErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Designation
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={PrimaryContactEmail}
                                    type="text"
                                    class="outside"
                                    required
                                    maxLength={30}
                                    onChange={(e) =>
                                      this.setState({
                                        PrimaryContactEmail: e.target.value,
                                        PrimaryContactEmailErr: "",
                                      })
                                    }
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {PrimaryContactEmailErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Email<span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={PrimaryContactMobile}
                                    type="text"
                                    class="outside"
                                    required
                                    maxLength={30}
                                    onChange={(e) =>
                                      this.setState({
                                        PrimaryContactMobile:
                                          e.target.value.replace(/\D/, ""),
                                        PrimaryContactMobileErr: "",
                                      })
                                    }
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {PrimaryContactMobileErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Mobile<span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset
                        class={SameAsAbove ? "saveAsAbove_section" : ""}
                      >
                        <legend>Billing Address</legend>

                        <div class="mb-2">
                          <div class="bg">
                            <div class="chiller_cb">
                              <input
                                value={SameAsAbove}
                                id="SameAsAbove"
                                type="checkbox"
                                // onKeyDown={(e) => this.handleKeyDown(e)}
                                selected={SameAsAbove}
                                checked={SameAsAbove}
                                onClick={(e) => this.SameAsAbove(e)}
                                placeholder=""
                              />
                              <label
                                for="SameAsAbove"
                                style={{ color: "#979797" }}
                              >
                                Same As Above
                              </label>
                              <span></span>
                            </div>
                          </div>
                        </div>

                        <div class="outside_input_field">
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={SAAFirstName}
                                    type="text"
                                    class="outside"
                                    required
                                    onChange={(e) =>
                                      this.setState({
                                        SAAFirstName: e.target.value
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                          )
                                          .join(" "),
                                        SAAFirstNameErr: "",
                                      })
                                    }
                                    maxLength={30}
                                    disabled={SameAsAbove}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {SAAFirstNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    First Name{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={SAALastName}
                                    type="text"
                                    class="outside"
                                    required
                                    onChange={(e) =>
                                      this.setState({
                                        SAALastName: e.target.value
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                          )
                                          .join(" "),
                                        SAALastNameErr: "",
                                      })
                                    }
                                    maxLength={30}
                                    disabled={SameAsAbove}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {SAALastNameErr}
                                    </span>
                                  }

                                  <span class="floating-label-outside">
                                    Last Name{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    type="text"
                                    value={SAADesignation}
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        SAADesignation: e.target.value
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                          )
                                          .join(" "),
                                      })
                                    }
                                    disabled={SameAsAbove}
                                    maxLength={50}
                                  />

                                  <span class="floating-label-outside">
                                    Designation{" "}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={SAACompanyName}
                                    type="text"
                                    class="outside"
                                    required
                                    disabled={SameAsAbove}
                                    onChange={(e) =>
                                      this.setState({
                                        SAACompanyName: e.target.value
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                          )
                                          .join(" "),
                                        SAACompanyNameErr: "",
                                      })
                                    }
                                    maxLength={100}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {SAACompanyNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Organizer / Organization Name{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group floating-group floating-diff">
                                <select
                                  id="state"
                                  name="Entry Type"
                                  class="form-control floating-control"
                                  value={SAACountryId}
                                  disabled={SameAsAbove}
                                  // onKeyDown={(e) => this.handleKeyDown(e)}
                                  onChange={(e) => this.onSAACountryId(e)}
                                >
                                  <option>
                                    Country
                                    <span class="mendatory_class">*</span>
                                  </option>

                                  {countryList.length > 0 &&
                                    countryList.map((item) => (
                                      <option
                                        key={item.Countryid}
                                        value={item.Countryid}
                                      >
                                        {item.CountryName}
                                      </option>
                                    ))}
                                </select>
                                {
                                  <span className="text-danger text-start text-left d-block mt-1">
                                    {SAACountryIdErr}
                                  </span>
                                }
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={SAAStateId}
                                    type="text"
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    class="outside"
                                    required
                                    onChange={(e) => this.onSAAStateSearch(e)}
                                    autocomplete="off"
                                    maxLength={30}
                                    disabled={SameAsAbove}
                                  />
                                  {isSAADisplayStateList &&
                                    this.renderSAAStateList()}
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {SAAStateErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    State Name
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={SAACityId}
                                    type="text"
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    class="outside"
                                    required
                                    onChange={(e) => this.onSAACitytSearch(e)}
                                    autocomplete="off"
                                    disabled={SameAsAbove}
                                    maxLength={30}
                                  />
                                  {isSAADisplayCityList &&
                                    this.renderSAACityList()}
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {SAACityNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    City Name
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={SAAAddressLine1}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        SAAAddressLine1: e.target.value
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                          )
                                          .join(" "),
                                        SAAAddressLine1Err: "",
                                      })
                                    }
                                    disabled={SameAsAbove}
                                    maxLength={70}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {SAAAddressLine1Err}
                                    </span>
                                  }

                                  <span class="floating-label-outside">
                                    Address Line 1{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    type="text"
                                    value={SAAAddressLine2}
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        SAAAddressLine2: e.target.value
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                          )
                                          .join(" "),
                                        SAAAddressLine2Err: "",
                                      })
                                    }
                                    disabled={SameAsAbove}
                                    maxLength={70}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {SAAAddressLine2Err}
                                    </span>
                                  }

                                  <span class="floating-label-outside">
                                    Address Line 2{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={SAAPincode}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        SAAPincode: e.target.value.replace(
                                          /\D/,
                                          ""
                                        ),
                                        SAAPincodeErr: "",
                                      })
                                    }
                                    disabled={SameAsAbove}
                                    maxLength={20}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {SAAPincodeErr}
                                    </span>
                                  }

                                  <span class="floating-label-outside">
                                    {SAACountryId == "91" ||
                                    SAACountryId == "" ||
                                    SAACountryId == "Country*"
                                      ? "Pincode"
                                      : "ZipCode"}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="tel_number">
                                  <div class="ISD">
                                    <input
                                      type="text"
                                      class="outside"
                                      placeholder="ISD"
                                      required
                                      value={SAAISD}
                                      disabled={true}
                                    />
                                  </div>
                                  <div class="position-relative width_80">
                                    <input
                                      value={SAAMobile1}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) =>
                                        this.setState({
                                          SAAMobile1: e.target.value.replace(
                                            /\D/,
                                            ""
                                          ),
                                          SAAMobile1Err: "",
                                        })
                                      }
                                      maxLength={10}
                                      disabled={SameAsAbove}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {SAAMobile1Err}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      Mobile 1{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="tel_number">
                                  <div class="ISD">
                                    <input
                                      type="text"
                                      class="outside"
                                      placeholder="ISD"
                                      required
                                      value={SAAISD}
                                      disabled={true}
                                    />
                                  </div>
                                  <div class="position-relative width_80">
                                    <input
                                      value={SAAMobile2}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) =>
                                        this.setState({
                                          SAAMobile2: e.target.value.replace(
                                            /\D/,
                                            ""
                                          ),
                                        })
                                      }
                                      maxLength={countryId == "91" ? 10 : 11}
                                      disabled={SameAsAbove}
                                    />

                                    <span class="floating-label-outside">
                                      Mobile 2{" "}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="tel_number">
                                  <div class="ISD">
                                    <input
                                      type="text"
                                      class="outside"
                                      onChange={(e) =>
                                        this.setState({
                                          preTel: e.target.value,
                                        })
                                      }
                                      placeholder={
                                        SAACountryId == "91" ||
                                        SAACountryId == "" ||
                                        SAACountryId == "Country*"
                                          ? "STD"
                                          : "ISD"
                                      }
                                      value={SAAPreTel}
                                      required
                                      disabled={SameAsAbove}
                                    />
                                  </div>
                                  {SAACountryId != "91" &&
                                  SAACountryId != "" &&
                                  SAACountryId != "Country*" ? (
                                    <div class="ISD">
                                      <input
                                        type="text"
                                        class="outside"
                                        onChange={(e) =>
                                          this.setState({
                                            SAAAreaCode: e.target.value,
                                          })
                                        }
                                        placeholder="CODE"
                                        value={SAAAreaCode}
                                        required
                                        disabled={SAAAreaCode}
                                      />
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  <div class="position-relative width_80">
                                    <input
                                      value={SAATelephoneNumber}
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      type="text"
                                      class="outside"
                                      required
                                      onChange={(e) =>
                                        this.setState({
                                          SAATelephoneNumber:
                                            e.target.value.replace(/\D/, ""),
                                        })
                                      }
                                      disabled={SameAsAbove}
                                      maxLength={16}
                                    />
                                    <span class="floating-label-outside">
                                      Telephone Number{" "}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    type="text"
                                    value={SAAPrimaryEmailID}
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        SAAPrimaryEmailID: e.target.value,
                                        SAAPrimaryEmailIDErr: "",
                                      })
                                    }
                                    disabled={SameAsAbove}
                                    maxLength={50}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {SAAPrimaryEmailIDErr}
                                    </span>
                                  }

                                  <span class="floating-label-outside">
                                    Primary Email ID{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={SAASecondaryEmailID}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        SAASecondaryEmailID: e.target.value,
                                      })
                                    }
                                    disabled={SameAsAbove}
                                    maxLength={50}
                                  />

                                  <span class="floating-label-outside">
                                    Secondary Email ID{" "}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={SAAWebsite}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        SAAWebsite: e.target.value,
                                      })
                                    }
                                    disabled={SameAsAbove}
                                    maxLength={40}
                                  />

                                  <span class="floating-label-outside">
                                    Website{" "}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      {countryId == "91" ? (
                        <fieldset>
                          <legend>
                            Organizer's / Organization's Information
                          </legend>
                          <div class="outside_input_field ">
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={registrationNumber}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) =>
                                        this.setState({
                                          registrationNumber:
                                            e.target.value.toUpperCase(),
                                        })
                                      }
                                      maxLength={20}
                                    />
                                    <span class="floating-label-outside">
                                      Registration Number{" "}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={PANCardNo}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) =>
                                        this.setState({
                                          PANCardNo:
                                            e.target.value.toUpperCase(),
                                          PANCardNoErr: "",
                                        })
                                      }
                                      maxLength={10}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {PANCardNoErr}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      PAN Card No.{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={NameonPANCard}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) =>
                                        this.setState({
                                          NameonPANCard: e.target.value
                                            .split(" ")
                                            .map(
                                              (word) =>
                                                word.charAt(0).toUpperCase() +
                                                word.slice(1)
                                            )
                                            .join(" "),
                                          NameonPANCardErr: "",
                                        })
                                      }
                                      maxLength={50}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {NameonPANCardErr}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      Name on PAN Card{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={GSTNo}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) =>
                                        this.setState({
                                          GSTNo: e.target.value.toUpperCase(),
                                        })
                                      }
                                    />
                                    <span class="floating-label-outside">
                                      GST No.{" "}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={TANNumber}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) =>
                                        this.setState({
                                          TANNumber:
                                            e.target.value.toUpperCase(),
                                        })
                                      }
                                      maxLength={20}
                                    />
                                    <span class="floating-label-outside">
                                      TAN Number{" "}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="col-md-4">
                                <div class="form-group">
                                  <div class="position-relative">
                                    <input
                                      value={UINNumber}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) =>
                                        this.setState({
                                          UINNumber:
                                            e.target.value.toUpperCase(),
                                        })
                                      }
                                      maxLength={20}
                                    />
                                    <span class="floating-label-outside">
                                      UIN Number{" "}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </fieldset>
                      ) : (
                        <></>
                      )}
                      <fieldset>
                        <legend>Banking details</legend>
                        <div class="outside_input_field ">
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={accountName}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        accountName: e.target.value
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                          )
                                          .join(" "),
                                        accountNameErr: "",
                                      })
                                    }
                                    maxLength={50}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {accountNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Account Name{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={accountNo}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        accountNo: e.target.value.replace(
                                          /\D/,
                                          ""
                                        ),
                                        accountNoErr: "",
                                      })
                                    }
                                    maxLength={30}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {accountNoErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Account No.{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group floating-group floating-diff">
                                <select
                                  id="state"
                                  name="Entry Type"
                                  class="form-control floating-control"
                                  value={accountType}
                                  onChange={(e) =>
                                    this.setState({
                                      accountType: e.target.value,
                                      accountTypeErr: "",
                                    })
                                  }
                                >
                                  <option>
                                    Account Type
                                    <span class="mendatory_class">*</span>
                                  </option>

                                  {accountTypeList.length > 0 &&
                                    accountTypeList.map((item) => (
                                      <option>{item.Accounttype}</option>
                                    ))}
                                </select>
                                {
                                  <span className="text-danger text-start text-left d-block mt-1">
                                    {accountTypeErr}
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={bankName}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        bankName: e.target.value
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                          )
                                          .join(" "),
                                        bankNameErr: "",
                                      })
                                    }
                                    maxLength={50}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {bankNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Bank name{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={branchName}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        branchName: e.target.value
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                          )
                                          .join(" "),
                                        branchNameErr: "",
                                      })
                                    }
                                    maxLength={30}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {branchNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    branch name{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={IFSCCode}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        IFSCCode: e.target.value.toUpperCase(),
                                        IFSCCodeErr: "",
                                      })
                                    }
                                    maxLength={20}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {IFSCCodeErr}
                                    </span>
                                  }

                                  <span class="floating-label-outside">
                                    {countryId == "91" ||
                                    countryId == "" ||
                                    countryId == "Country*"
                                      ? "IFSC code"
                                      : "Swift code"}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <div className="row">
                        <div className="mx-3">
                          <a
                            href="javascript:void(0);"
                            onClick={(e) => this.handleSubmit(e)}
                            className="btn save_btn"
                          >
                            {ClientID ? "Update" : "Save"}
                          </a>
                        </div>
                        <div className="">
                          <a
                            href="javascript:void(0);"
                            onClick={() => this.navigateBackCLient()}
                            className="btn back_btn"
                          >
                            Back
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, { client_add_action, client_detail_action, fill_action })(
    ClientAdd
  )
);
